// A wrapper for <Route> that requires public user token to be set in local storage.
import { Outlet } from 'react-router-dom'
import { getPublicUserWithToken } from 'utils/localStorage'

const PublicTokenRoute = ({ children }) => {
  getPublicUserWithToken()
  return children ? children : <Outlet />
}

export default PublicTokenRoute
